/* ==========================================================================
 * Styleguide JavaScript. The contents of this file are taken from:
 * https://github.com/rawson-properties/website-styleguide/blob/master/src/assets/js/main.js
 * ========================================================================== */

(function () {
    'use strict';

    const $ = require('jquery');
    const Typed = require('typed.js');
    require('magnific-popup');
    const flatpickr = require('flatpickr').default;

    /* ==========================================================================
     * Alert
     * ========================================================================== */

    var $alert_component = $('.js-alert');
    $alert_component.each(function () {
        var $alert = $(this);
        var $dismiss_alert = $('.js-dismiss', $alert);

        $dismiss_alert.on('click', function (e) {
            e.preventDefault();

            $alert.fadeOut(250);
        });
    });

    /* ==========================================================================
     * Button Dropdown
     * ========================================================================== */

    var $button_dropdown = $('.js-btn-dropdown');

    $button_dropdown.each(function () {
        var $button = $('.btn', $(this));

        $button.on('click', function () {

            /*
             * Open the current dropdown
             */

            $(this).toggleClass('is-active');

            var dropdown_id = $(this).data('dropdown-id');
            var $dropdown = $('#' + dropdown_id);

            if ($dropdown.length > 0) {
                $dropdown.toggleClass('is-open');

                /*
                 * Toggle ARIA attributes
                 */

                if ($dropdown.hasClass('is-open')) {
                    $dropdown.attr('aria-hidden', 'false');
                } else {
                    $dropdown.attr('aria-hidden', 'true');
                }

                /*
                 * Close all other dropdowns
                 */

                var $dropdowns = $('.dropdown', $button_dropdown);

                $dropdowns.not($dropdown).each(function () {
                    $(this).removeClass('is-open');
                    $(this).attr('aria-hidden', 'true');
                });
            }
        });
    });

    /* ==========================================================================
     * Collapse
     * ========================================================================== */

    var $collapse_component = $('.js-collapse');

    $collapse_component.each(function () {
        var $collapse = $(this);
        var collapse_id = $collapse.data('collapse-id');
        var icon_up = $collapse.data('icon-up');
        var icon_down = $collapse.data('icon-down');
        var $anchor_icon = $('.icon', $collapse);

        /*
         * Show the toggle
         */

        $collapse.removeClass('u-hidden');

        /*
         * Collapse all elements
         */

        if (typeof collapse_id !== 'undefined') {
            var $el = $('#' + collapse_id);

            if ($el.length > 0) {
                $el.addClass('collapse');
            }

            /*
             * Open the collapsed element by default
             */

            var collapse_open = $collapse.data('collapse-open');

            if (typeof collapse_open !== 'undefined') {
                if (collapse_open) {
                    $el.addClass('is-open');
                }
            }
        }

        $collapse.on('click', function (e) {
            e.preventDefault();

            /*
             * Toggle the display of the element
             */

            $el.toggleClass('is-open');

            /*
             * Focus on the first form input
             */

            if ($el.find('input').length > 0) {
                $el.find('input').first().focus();
            }

            /*
             * Set the active class on the toggle
             */

            var collapse_toggle = $collapse.data('collapse-toggle');

            if (typeof collapse_toggle !== 'undefined') {
                if (collapse_toggle) {
                    $collapse.toggleClass('is-active');
                }
            }

            /*
             * Hide the toggle after the element display has been toggled
             */

            var hide_toggle = $collapse.data('hide-toggle');

            if (typeof hide_toggle !== 'undefined') {
                if (hide_toggle) {
                    $collapse.hide();
                }
            }

            /*
             * Toggle button icons
             */

            if ($el.hasClass('is-open')) {
                $anchor_icon.removeClass(icon_down).addClass(icon_up);
            } else {
                $anchor_icon.removeClass(icon_up).addClass(icon_down);
            }
        });
    });

    /* ==========================================================================
     * Date Picker
     * ========================================================================== */
    flatpickr('.js-date-picker', {
        enableTime: true,
    });

    /* ==========================================================================
     * Lightbox
     * ========================================================================== */

    var lightbox = function () {
        var $lightbox = $('.js-lightbox');

        $lightbox.each(function () {

            /*
             * Initialize the lightbox
             */

            $(this).magnificPopup({
                closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span class="icon icon-close" aria-hidden="true"></span></button>',
                delegate: '.js-lightbox-image',
                gallery: {
                    enabled: true,
                    preload: [0, 1,],
                },
                type: 'image',
            });

            /*
             * Close
             */

            $(document).on('click', '.mfp-close', function () {
                $.magnificPopup.close();
            });

            /*
             * Show the overlay
             */

            var $gallery_overlay = $('.js-lightbox-overlay', $(this));

            if ($gallery_overlay.length > 0) {
                $gallery_overlay.removeClass('u-hidden');
            }
        });
    };

    lightbox();

    /* ==========================================================================
     * Menu Dropdown
     * ========================================================================== */

    var $menu_dropdown = $('.js-menu-dropdown');

    if ($menu_dropdown.length > 0) {
        var icon_up = $menu_dropdown.data('icon-up');
        var icon_down = $menu_dropdown.data('icon-down');

        $('a', $menu_dropdown).each(function () {
            var $anchor = $(this);
            var $anchor_icon = $('.icon', $anchor);
            var $menu = $anchor.next('.js-menu');

            $anchor.on('click', function (e) {

                /*
                 * Toggle the dropdown menu
                 */

                if ($(this).next().hasClass('js-menu')) {
                    e.preventDefault();

                    $menu.toggleClass('is-open');

                    if ($menu.hasClass('is-open')) {
                        $menu.attr('aria-hidden', 'false');
                        $anchor_icon.removeClass(icon_down).addClass(icon_up);
                    } else {
                        $menu.attr('aria-hidden', 'true');
                        $anchor_icon.removeClass(icon_up).addClass(icon_down);
                    }
                }

                /*
                 * Close all other open menus
                 */

                var $menu_other = $('.js-menu', $menu_dropdown).not($menu);
                $menu_other.removeClass('is-open').attr('aria-hidden', 'true');

                /*
                 * Reset icon of all other menu anchors
                 */

                var $anchor_other_icon = $('.icon', $menu_other.prev());
                $anchor_other_icon.removeClass(icon_up).addClass(icon_down);
            });
        });

        /*
         * Close all open menus on click outside of menu
         */

        $(document).on('click', function (e) {
            if (!$(e.target).closest($menu_dropdown).length > 0) {
                var $menus = $('.js-menu', $menu_dropdown);

                if ($menus.hasClass('is-open')) {
                    var $menu_icons = $('.icon', $menu_dropdown);
                    $menus.removeClass('is-open').attr('aria-hidden', 'true');
                    $menu_icons.removeClass(icon_up).addClass(icon_down);
                }
            }
        });
    }

    /* ==========================================================================
     * Modal
     * ========================================================================== */

    var $modal = $('.js-modal');

    $modal.each(function () {
        var $trigger = $(this);
        var $close = $('.modal-close');

        $trigger.on('click', function (e) {
            e.preventDefault();

            var modal_id = $(this).data('modal-id');

            if (typeof modal_id !== 'undefined') {
                var $modal = $('#' + modal_id);
                var $video = $('.js-video', $modal);
                var $video_href = $video.attr('src');
                var $video_autoplay = $video_href + '?autoplay=1';

                if ($modal.length > 0) {
                    $modal.modal('show');
                    $video.attr('src', $video_autoplay);
                }

                $close.on('click', function (e) {
                    e.preventDefault();

                    $video.attr('src', $video_href);
                });
            }
        });
    });

    /* ==========================================================================
     * Navigation Toggle
     * ========================================================================== */

    $(document).on('click', '.js-nav-toggle', function (e) {
        e.preventDefault();

        var $nav_toggle = $(this);
        var $nav = $('.js-nav');
        var $header = $('.js-header');

        if ($nav.length > 0) {
            $nav.toggleClass('is-open');
            $nav_toggle.toggleClass('is-active');
            $header.toggleClass('is-open');
        }
    });

    /* ==========================================================================
     * Replace
     * ========================================================================== */

    var $replace_component = $('.js-replace');
    $replace_component.each(function () {
        var $replace = $(this);
        var replace = $(this).data('replace');
        var href = $(this).data('href');

        $replace.on('click', function (e) {
            e.preventDefault();

            if (href) {
                $(this).replaceWith(`<a href="${href}">${replace}</a>`);
            } else {
                $(this).replaceWith(replace);
            }
        });
    });

    /* ==========================================================================
     * Scroll To
     * ========================================================================== */

    var $scroll_to_component = $('.js-scroll-to');
    $scroll_to_component.each(function () {
        var $scroll = $(this);
        var href = $scroll.attr('href');

        $scroll.on('click', function (e) {
            e.preventDefault();

            if (typeof href !== 'undefined') {
                var $to = $(href);

                if ($to.length > 0) {
                    $('html, body').animate({
                        scrollTop: $to.offset().top,
                    }, 250);
                }
            }
        });
    });

    /* ==========================================================================
     * Tabs
     * ========================================================================== */

    var $tabs_component = $('.js-tabs');
    $tabs_component.each(function () {
        var $tabs = $(this);
        var $tablist = $('.tab-list', $tabs);
        var $tablist_link = $('a', $tablist);

        $tablist_link.on('click', function (e) {
            e.preventDefault();

            var $link = $(this);
            var $tab = $link.parent();
            var tab_panel_id = $tab.attr('aria-controls');
            var $tab_panel = $('#' + tab_panel_id);

            /*
             * Reset the display of all other tabs
             */

            $('.tab-list li', $tabs).not($tab).removeClass('is-selected').attr('aria-selected', 'false');
            $('.tab-panel', $tabs).not($tab_panel).removeClass('is-selected').attr('aria-hidden', 'true');

            /*
             * Display the selected tab
             */

            if (!$tab.hasClass('is-selected')) {
                $tab.attr('aria-selected', 'true');
                $tab.addClass('is-selected');
                $tab_panel.addClass('is-selected');
                $tab_panel.attr('aria-hidden', 'false');
            }
        });
    });

    /* ==========================================================================
     * Typed
     * ========================================================================== */

    var $typed = $('.js-typed');
    $typed.each(function () {
        new Typed('.typed-sentence', {
            // strings: [ 'Property', 'Selling', 'Buying', 'Finance', 'Renting', 'Letting', ],
            strings: [ 'Buy', 'Sell', ],
            typeSpeed: 70,
            startDelay: 100,
            backSpeed: 50,
            backDelay: 2500,
            loop: true,
            loopCount: false,
        });
    });
})();
